import React from 'react';
import { SPEEDTEST_SIZES } from '../../hooks/useSpeedTest';

// Segmented size picker shown before a run — shared between the portal and technical speed
// test pages. Bigger sizes take longer but are what actually gets past a router queue's burst
// allowance (see useSpeedTest.js), so this is the real fix when a result reads way too high.
export default function SpeedTestSizePicker({ value, onChange, disabled }) {
  return (
    <div style={{ display: 'flex', gap: 8, width: '100%' }}>
      {SPEEDTEST_SIZES.map((s) => {
        const active = s.bytes === value;
        return (
          <button
            key={s.label}
            type="button"
            disabled={disabled}
            onClick={() => onChange(s.bytes)}
            style={{
              flex: 1, padding: '7px 4px', fontSize: '.72rem', fontWeight: 600,
              borderRadius: 10, cursor: disabled ? 'default' : 'pointer',
              border: `1px solid ${active ? 'var(--primary, #1e3a8a)' : '#e2e5eb'}`,
              background: active ? 'var(--primary, #1e3a8a)' : '#fff',
              color: active ? 'var(--c-ffffff)' : 'var(--c-4b5563)',
              opacity: disabled && !active ? .6 : 1,
            }}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
